import { create } from "zustand";

export interface ShareTarget {
  customerId: string;
  name?: string;
  avatarUri?: string;
}

export interface ShareSentRecord {
  shareId: string;
  recipientId: string;
  sharedAt: number;
}

interface SharingState {
  shareTargets: ShareTarget[];
  sharesSent: ShareSentRecord[];
  isLoadingTargets: boolean;
  isSharing: boolean;
  shareSuccess: string | null;
  shareError: string | null;

  setShareTargets: (targets: ShareTarget[]) => void;
  setLoadingTargets: (v: boolean) => void;
  setSharesSent: (shares: ShareSentRecord[]) => void;
  setSharing: (v: boolean) => void;
  setShareSuccess: (recipientId: string | null) => void;
  setShareError: (error: string | null) => void;
  reset: () => void;
}

export const useSharingStore = create<SharingState>((set) => ({
  shareTargets: [],
  sharesSent: [],
  isLoadingTargets: false,
  isSharing: false,
  shareSuccess: null,
  shareError: null,

  setShareTargets: (targets) => set({ shareTargets: targets, isLoadingTargets: false }),
  setLoadingTargets: (v) => set({ isLoadingTargets: v }),
  setSharesSent: (shares) => set({ sharesSent: shares }),
  setSharing: (v) => set({ isSharing: v }),
  // Records a per-recipient success but does NOT clear isSharing — a multi-
  // recipient batch stays "sharing" until ShareModal sees all recipients
  // resolved (otherwise the first confirmation would re-enable the UI mid-batch).
  setShareSuccess: (recipientId) => set({ shareSuccess: recipientId }),
  setShareError: (error) => set({ shareError: error, isSharing: false }),
  reset: () => set((state) => ({ shareTargets: state.shareTargets, sharesSent: [], isLoadingTargets: false, isSharing: false, shareSuccess: null, shareError: null })),
}));
